var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01339 1.94043C5.80673 1.94043 4.01339 3.73376 4.01339 5.94043V7.8671C4.01339 8.27376 3.84006 8.89376 3.63339 9.24043L2.86673 10.5138C2.39339 11.3004 2.72006 12.1738 3.58673 12.4671C6.46006 13.4271 9.56006 13.4271 12.4334 12.4671C13.2401 12.2004 13.5934 11.2471 13.1534 10.5138L12.3867 9.24043C12.1867 8.89376 12.0134 8.27376 12.0134 7.8671V5.94043C12.0134 3.74043 10.2134 1.94043 8.01339 1.94043Z",
    stroke: "#6777A2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24694 2.13395C9.04027 2.07395 8.82694 2.02728 8.60694 2.00061C7.96694 1.92061 7.35361 1.96728 6.78027 2.13395C6.97361 1.64061 7.45361 1.29395 8.01361 1.29395C8.57361 1.29395 9.05361 1.64061 9.24694 2.13395Z",
    stroke: "#6777A2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0127 12.7061C10.0127 13.8061 9.1127 14.7061 8.0127 14.7061C7.46603 14.7061 6.95936 14.4794 6.59936 14.1194C6.23936 13.7594 6.0127 13.2527 6.0127 12.7061",
    stroke: "#6777A2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6cb7753daa9deef954c5f89dc7c70527.svg";
export { ForwardRef as ReactComponent };